import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IScimContext } from '../types/IScimContext';

export interface IGetScimContextParams {
}

export class GetScimContextRequest extends Request<IGetScimContextParams, IScimContext> {
  constructor() {
    super('getScimContext', null);
  }
}
